import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import chat from "./modules/chat";
import platform from "@/store/modules/platform";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    chat,
    platform
  }
});
